import { render, staticRenderFns } from "./bank_pay.vue?vue&type=template&id=ec8cba3a&scoped=true&"
import script from "./bank_pay.vue?vue&type=script&lang=js&"
export * from "./bank_pay.vue?vue&type=script&lang=js&"
import style0 from "./bank_pay.vue?vue&type=style&index=0&id=ec8cba3a&prod&lang=less&scoped=true&"
import style1 from "./bank_pay.vue?vue&type=style&index=1&id=ec8cba3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8cba3a",
  null
  
)

export default component.exports